import i18n from '@/i18n/config';

export class AttachmentReadError extends Error {
  readonly clientId?: string;

  constructor(filename: string, clientId?: string) {
    super(i18n.t('dialog.attachments.readFailed', { filename }));
    this.name = 'AttachmentReadError';
    this.clientId = clientId;
  }
}

export async function materializeAttachment(params: {
  blob: Blob;
  filename: string;
  clientId?: string;
  sizeBytes?: number;
}): Promise<Blob> {
  try {
    const bytes = await params.blob.arrayBuffer();
    if (bytes.byteLength === 0 && (params.sizeBytes ?? params.blob.size) > 0) {
      throw new Error('Empty attachment read');
    }
    // WebKit 319985: wrapping a disk-backed File in a Blob is insufficient.
    // Read in the page process so multipart serialization receives memory bytes.
    return new Blob([bytes], { type: params.blob.type });
  } catch {
    throw new AttachmentReadError(params.filename, params.clientId);
  }
}
